module.exports = __webpack_public_path__ + "static/media/googleplus.d1c33cf3.png";